import { ref } from 'vue';
import { useRouter } from 'vue-router';

export const useNavbarTransition = () => {
    const showNavbar = ref(false);
    const showAddressBar = ref(false);
    const contentVisible = ref(false);
    const scrollPosition = ref(null);
    const router = useRouter();


    const scrollTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        });
    };
    const resetNavAnimation = () => {
        // Only hide navbar if user is scolled down
        if (scrollPosition.value > 170) {
            showNavbar.value = false;
            showAddressBar.value = false;
        }
        scrollTop();
    };

    const animateNavbar = () => {
        if (!showNavbar.value) {
            showNavbar.value = true;
        }
    };

    const setScrollPosition = () => {
        scrollPosition.value = window.scrollY;
    };

    const showContent = () => {
        const footer = document.querySelector('footer');
        footer.classList.add('show');
        footer.dataset.route = router.currentRoute.value.name;
        contentVisible.value = true;
    };

    return {
        showNavbar,
        showAddressBar,
        contentVisible,
        resetNavAnimation,
        animateNavbar,
        setScrollPosition,
        showContent,
    };
};
